// Time Tracking / Billable Hours domain.
import { API } from './_client';

export const time = {
  running: () => API.get('/time/running').then((r) => r.data),
  start: (payload) => API.post('/time/start', payload).then((r) => r.data),
  stop: (id) => API.post(`/time/stop/${id}`).then((r) => r.data),
  addManual: (payload) => API.post('/time', payload).then((r) => r.data),
  list: (opts = {}) => API.get('/time', { params: opts }).then((r) => r.data),
  timesheet: (opts = {}) => API.get('/time/timesheet', { params: opts }).then((r) => r.data),
  wip: () => API.get('/time/wip').then((r) => r.data),
  update: (id, patch) => API.patch(`/time/${id}`, patch).then((r) => r.data),
  remove: (id) => API.delete(`/time/${id}`).then((r) => r.data),
  xeroExport: (payload) => API.post('/time/xero-export', payload).then((r) => r.data),
};
